// Dev environment — ECS deployment
export const environment = {
  production: true,
  apiUrl: 'https://api.omni.dev.barkani.com',
  companyId: '3',
  title: 'Event Registration',
  features: {
    callPlan: false,
    showIsiPlaceholder: false
  }
};
